var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { limitNumberBetween } from "../../common/utils";
/**
 * Determinate / indeterminate progress bar for internal (ProgressIndicator) use.
 */
export var InternalProgressBar = function (_a) {
    var ariaLabel = _a.ariaLabel, _b = _a.width, width = _b === void 0 ? "100%" : _b, determinate = _a.determinate, _c = _a.progress, progress = _c === void 0 ? 0 : _c, _d = _a.valueColor, valueColor = _d === void 0 ? "#0972d3" : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? "#e9ebed" : _e;
    var value = limitNumberBetween(isNaN(progress) ? 0 : Math.round(progress), 0, 100);
    var ariaAttributes = {
        "aria-label": ariaLabel,
    };
    if (determinate) {
        ariaAttributes = __assign(__assign({}, ariaAttributes), { "aria-valuenow": value, "aria-valuemin": 0, "aria-valuemax": 100 });
    }
    return (_jsx("div", __assign({ role: "progressbar" }, ariaAttributes, { className: classNames("progress-bar", "center-horizontal-block", {
            indeterminate: !determinate,
        }), style: {
            width: width,
            backgroundColor: backgroundColor,
        } }, { children: _jsx("div", { className: "progress-bar-value", style: {
                backgroundColor: valueColor,
                width: determinate ? "".concat(value, "%") : "100%",
            } }) })));
};
